'use client'

import dynamic from 'next/dynamic'
import React, { useState, useEffect } from 'react'

const CookieBanner = dynamic(() => import('./cookie-banner'))

const CookieBannerWrapper = () => {
  const [isBannerVisible, setBannerVisible] = useState(false)

  useEffect(() => {
    const eventList = [
      'click',
      'keydown',
      'mousemove',
      'wheel',
      'touchmove',
      'touchstart',
      'touchend',
    ]
    const removeListeners = () => {
      eventList.forEach(event => {
        window.removeEventListener(event, handleUserInteraction)
      })
    }

    const handleUserInteraction = () => {
      setBannerVisible(true)
      removeListeners()
    }

    eventList.forEach(event => {
      window.addEventListener(event, handleUserInteraction, { passive: true })
    })

    return () => {
      removeListeners()
    }
  }, [])

  return (isBannerVisible && <CookieBanner />) || null
}

export default CookieBannerWrapper
